import "./ResearchAndCommentary.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PerformanceInsights from "./sections/PerformanceInsights";
import MultimediaLinks from "./sections/MultimediaLinks";
import SkillBuildingLaboratories from "./sections/SkillBuildingLaboratories";
import YeFooter from "@/reusable_sections/Footer";
export default function ResearchAndCommentaryPage() {
  return <div>
      <Header />
      <Hero />
      <PerformanceInsights />
      <MultimediaLinks />
      <SkillBuildingLaboratories />
      <YeFooter />
    </div>;
}